export const GET_CARD_DETAIL_SUCCESS = 'GET_CARD_DETAIL_SUCCESS';
export const SET_CARD_DETAIL = 'SET_CARD_DETAIL';

export const updateCard = (card) => {
	return {
		type: GET_CARD_DETAIL_SUCCESS,
		response: {
			card,
		},
	};
};

export const setCardDetail = (card) => {
	return {
		type: SET_CARD_DETAIL,
		card,
	};
};
